import {userConstants} from '../_constants';

export function wishlistFlagMessage(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_WISHLIST_FLAG_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_WISHLIST_FLAG_MESSAGE_SUCCESS:
      return {
        ...state,
        data: [...action.data],
        loading: false,
      };
    case userConstants.GET_WISHLIST_FLAG_MESSAGE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}